import {} from "../../request/api";

const state = {
    mapSwitch: 0,
};
const mutations = {
    changeMapSwitch(state, index) {
        state.mapSwitch = index;
    },
};
const actions = {

};

const getters = {
    mapSwitch(state) {
        return state.mapSwitch;
    }
};

export default {
    state,
    mutations,
    actions,
    getters,
    // 命名空间
    namespaced: true, //使用命名空间
}